export function getEnumObject<T extends number>(e) {
  return Object.fromEntries(getEnumKeys(e).map((n) => [e[n] as T, n]));
}

export function getEnumKeysAndValues<T extends number>(e) {
  return getEnumKeys(e).map((n) => ({ key: n, value: e[n] as T }));
}

export function getEnumKeys(e) {
  return getObjValues(e).filter((v) => typeof v === 'string') as string[];
}

export function getEnumValues<T extends number>(e) {
  return getObjValues(e).filter((v) => typeof v === 'number') as T[];
}

export function getEnumKeysUpTo<T extends number>(e, key) {
  return getEnumKeysAndValues(e)
    .filter(({ value }) => value <= key)
    .map(({ key, value }) => key);
}

export function getEnumKeysFrom<T extends number>(e, key) {
  return getEnumKeysAndValues(e)
    .filter(({ value }) => value >= key)
    .map(({ key, value }) => key);
}

export function getEnumSelectList<T extends number, U>(e, stringConverter: (arg: U) => string) {
  const selectList = new Map<T, string>();
  getEnumValues(e).forEach((val) => selectList.set(val as T, stringConverter(val as unknown as U)));
  return selectList;
}

export function getEnumSelectListAsArray<T extends number, U>(
  e,
  stringConverter: (arg: U) => string
) {
  return Array.from(getEnumSelectList(e, stringConverter), (value) => ({
    value: value[0] as T,
    presentation: value[1]
  }));
}

function getObjValues(e): (number | string)[] {
  return Object.keys(e).map((k) => e[k]);
}

export const getEnumVal = (e, value?: string | number) => {
  const enumKey = getEnumKeys(e)
    .filter((key) => String(key) == String(value))
    .map((key) => key)[0];
  if (enumKey !== undefined) return e[enumKey];

  const enumVal = getEnumValues(e)
    .filter((val) => String(val) == String(value))
    .map((val) => val)[0];
  if (enumVal !== undefined) return enumVal;

  return undefined;
};
